import React from 'react';
import { ClockIcon, SmartphoneIcon, MonitorIcon, MapPinIcon, ExternalLinkIcon, EyeIcon, FileTextIcon, WifiIcon, DownloadIcon, TruckIcon, PlayCircleIcon, BarChart4Icon } from 'lucide-react';
interface ActivityTimelineProps {
  openHeatmap: () => void;
}
export const ActivityTimeline: React.FC<ActivityTimelineProps> = ({
  openHeatmap
}) => {
  const sessions = [{
    id: 1,
    date: 'I dag',
    start: '10:23',
    end: '10:42',
    duration: '00:19',
    device: 'desktop',
    location: 'København',
    referrer: 'E-mail kampagne',
    events: [{
      id: 1,
      type: 'view',
      scenario: 'Better',
      time: '10:24'
    }, {
      id: 2,
      type: 'compare',
      time: '10:26'
    }, {
      id: 3,
      type: 'addon',
      name: 'WiFi-termostater',
      time: '10:30'
    }, {
      id: 4,
      type: 'download',
      time: '10:35'
    }, {
      id: 5,
      type: 'shipping',
      time: '10:38'
    }]
  }, {
    id: 2,
    date: 'I går',
    start: '14:05',
    end: '14:31',
    duration: '00:26',
    device: 'mobile',
    location: 'København',
    referrer: 'Direkte',
    events: [{
      id: 1,
      type: 'view',
      scenario: 'Good',
      time: '14:07'
    }, {
      id: 2,
      type: 'view',
      scenario: 'Better',
      time: '14:12'
    }, {
      id: 3,
      type: 'view',
      scenario: 'Best',
      time: '14:18'
    }, {
      id: 4,
      type: 'compare',
      time: '14:22'
    }, {
      id: 5,
      type: 'roi',
      time: '14:28'
    }]
  }];
  return <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5 mb-6" data-id="element-17">
      <h2 className="text-lg font-medium mb-4 flex items-center gap-2" data-id="element-18">
        <BarChart4Icon size={18} className="text-red-600 flex-shrink-0" data-id="element-19" />
        <span className="truncate" data-id="element-20">Aktivitets-tidslinje</span>
      </h2>
      <div className="space-y-6" data-id="element-21">
        {sessions.map(session => <div key={session.id} className="border-l-2 border-gray-200 pl-4 pb-2" data-id="element-22">
            <div className="flex flex-wrap items-center justify-between mb-3 gap-2" data-id="element-23">
              <div className="flex flex-wrap items-center gap-2" data-id="element-24">
                <span className="font-medium whitespace-nowrap" data-id="element-25">
                  {session.date}, {session.start}–{session.end}
                </span>
                <span className="text-sm text-gray-500 flex items-center gap-1 whitespace-nowrap" data-id="element-26">
                  <ClockIcon size={14} className="flex-shrink-0" data-id="element-27" />{' '}
                  {session.duration}
                </span>
                <span className="text-sm text-gray-500 flex items-center gap-1 whitespace-nowrap" data-id="element-28">
                  {session.device === 'desktop' ? <MonitorIcon size={14} className="flex-shrink-0" data-id="element-29" /> : <SmartphoneIcon size={14} className="flex-shrink-0" data-id="element-30" />}
                  {session.device === 'desktop' ? 'Desktop' : 'Mobil'}
                </span>
                <span className="text-sm text-gray-500 flex items-center gap-1 whitespace-nowrap" data-id="element-31">
                  <MapPinIcon size={14} className="flex-shrink-0" data-id="element-32" />{' '}
                  {session.location}
                </span>
              </div>
              <div className="flex items-center gap-2 flex-wrap" data-id="element-33">
                <span className="text-sm text-gray-500 flex items-center gap-1 whitespace-nowrap" data-id="element-34">
                  <ExternalLinkIcon size={14} className="flex-shrink-0" data-id="element-35" />{' '}
                  {session.referrer}
                </span>
                <button className="text-sm text-red-600 flex items-center gap-1 border border-red-200 rounded-md px-2 py-1 hover:bg-red-50 whitespace-nowrap" onClick={openHeatmap} data-id="element-36">
                  <PlayCircleIcon size={14} className="flex-shrink-0" data-id="element-37" /> Afspil
                  session
                </button>
              </div>
            </div>
            <div className="space-y-2 ml-2" data-id="element-38">
              {session.events.map(event => <div key={event.id} className="flex items-center gap-2 text-sm" data-id="element-39">
                  <span className="text-gray-400 whitespace-nowrap" data-id="element-40">
                    {event.time}
                  </span>
                  {event.type === 'view' && <div className="flex items-center gap-1 bg-blue-50 px-2 py-1 rounded" data-id="element-41">
                      <EyeIcon size={14} className="text-blue-500 flex-shrink-0" data-id="element-42" />
                      <span className="truncate" data-id="element-43">Viste {event.scenario}</span>
                    </div>}
                  {event.type === 'compare' && <div className="flex items-center gap-1 bg-purple-50 px-2 py-1 rounded" data-id="element-44">
                      <FileTextIcon size={14} className="text-purple-500 flex-shrink-0" data-id="element-45" />
                      <span className="truncate" data-id="element-46">Åbnede Sammenligning</span>
                    </div>}
                  {event.type === 'addon' && <div className="flex items-center gap-1 bg-green-50 px-2 py-1 rounded" data-id="element-47">
                      <WifiIcon size={14} className="text-green-500 flex-shrink-0" data-id="element-48" />
                      <span className="truncate" data-id="element-49">Tilkøb: {event.name}</span>
                    </div>}
                  {event.type === 'download' && <div className="flex items-center gap-1 bg-yellow-50 px-2 py-1 rounded" data-id="element-50">
                      <DownloadIcon size={14} className="text-yellow-600 flex-shrink-0" data-id="element-51" />
                      <span className="truncate" data-id="element-52">Download materialeliste</span>
                    </div>}
                  {event.type === 'shipping' && <div className="flex items-center gap-1 bg-orange-50 px-2 py-1 rounded" data-id="element-53">
                      <TruckIcon size={14} className="text-orange-500 flex-shrink-0" data-id="element-54" />
                      <span className="truncate" data-id="element-55">Åbnede Fragt & Rabatter</span>
                    </div>}
                  {event.type === 'roi' && <div className="flex items-center gap-1 bg-teal-50 px-2 py-1 rounded" data-id="element-56">
                      <BarChart4Icon size={14} className="text-teal-500 flex-shrink-0" data-id="element-57" />
                      <span className="truncate" data-id="element-58">Åbnede TCO/ROI</span>
                    </div>}
                </div>)}
            </div>
          </div>)}
      </div>
    </div>;
};